export const STOCKS = {
  CHJ: { name: '청자방',   emoji: '🏺', dMin: 0.005, dMax: 0.015 },
  BDS: { name: '비단상단', emoji: '🧵', dMin: 0.010, dMax: 0.030 },
  HYB: { name: '화약방',   emoji: '🧨', dMin: 0.020, dMax: 0.080 },
} as const;

export const LEV_NAMES: Record<number, string> = {
  1: '자기돈', 5: '차용', 10: '큰빚', 50: '고리대금', 100: '사채',
};

export const LEVERAGES = [1, 5, 10, 50, 100] as const;

export const START_CASH = 50_000_000;
export const AD_REWARD  = 10_000_000;
export const REVIVE_REWARD = 30_000_000;
export const DEBT_FORGIVE_BONUS = 10_000_000;
export const AD_DAILY_MAX = 3;
export const BROKE_LINE = 10_000;
export const CHART_LEN = 120;
export const BOOST_COOLDOWN_MS = 60_000;

// 노역
export const LABOR_TREE_COUNT = 15;
export const LABOR_DAILY_BASE = 1;
export const LABOR_DAILY_MAX = 3;
export const LABOR_GOLD_PROB = 0.01;
export const LABOR_BASE_PROB = 0.01;
export const LABOR_PROB_STEP = 0.01;
export const LABOR_REWARD_MIN = 1_000_000;
export const LABOR_REWARD_MAX = 10_000_000;
export const LABOR_GOLD_MIN = 100_000_000;
export const LABOR_GOLD_MAX = 1_000_000_000;

// 가격 엔진
export const UP_BIAS = 0.5005; // 50.05:49.95 우상향

// 한국 만진수 단위 (높은 단위 → 낮은 단위)
export const KOR_UNITS: Array<[string, number]> = [
  ['무량대수', 1e68], ['불가사의', 1e64], ['나유타', 1e60], ['아승기', 1e56],
  ['항하사', 1e52], ['극', 1e48], ['재', 1e44], ['정', 1e40],
  ['간', 1e36], ['구', 1e32], ['양', 1e28], ['자', 1e24],
  ['해', 1e20], ['경', 1e16], ['조', 1e12], ['억', 1e8], ['만', 1e4],
];

// 랭킹 mock 닉네임 풀
export const MOCK_NAMES = [
  '왕건','강감찬','김유신','을지문덕','최영','이성계','정몽주','문익점','정도전','신돈',
  '서희','윤관','정중부','이의민','최충헌','장보고','연개소문','계백','관창','김춘추',
  '안중근','유관순','김구','홍길동','임꺽정','전봉준','김좌진','이순신','권율','곽재우',
  '의자왕','광개토','동명성왕','단군','선덕여왕','미실','진평왕','선화공주','평강공주','온달',
  '임청산','박단타','김존버','이청산','최물타기','조영끌','한갭손','정고리','이사채','박빚탕',
];
